// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"970942b4","239":"bd7d8723","455":"4ee4afad"}[chunkId] + ".chunk.js";
};